TS.ns('WL');

WL.leasingOfferBase = new Class({
    Extends: WL.documentBase,
     
    createProperties: function (config) {
        var me = this;

        me.parent(config);
        var simulationList = me.getDomainProperty('grdSimulations_Property');

        cat = simulationList.Commands;

        newCmd = new TS.domain.Command();
        newCmd['Code'] = 'AddSimulation';
        newCmd['Text'] = me.AddSimulationCommandText;
        newCmd['handler'] = '_addSimulation';
        newCmd['IconCode'] = 'plus';

        if (!me.ReadOnly())
            cat.push(newCmd); 

        simulationList.on('cellBeginEdit', me.onSimulationBeginEdit);

        me.lkpResponsible_Property.on('selectionChanged', me.onResponsibleIdChanged, me);

        documentChecklistList = me.getDomainProperty('dgCheckList_Property');
        if (documentChecklistList != null) {
            documentChecklistList.on('afterAdd', me.onChecklistAdded);
            documentChecklistList.on('cellValueChanged', me.onChecklistChanged);
        }

        var partnerList = me.getDomainProperty('dgLeasingPartnerCollection_Property');
        if (partnerList) {
            partnerList.on('afterAdd', me.onPartnerAdded);
            partnerList.getFieldByName('gcPartner_Field').allowInput = false;
            partnerList.getFieldByName('gcPartnerForDealers_Field').allowInput = false;
            partnerList.getFieldByName('gcPartner_Field').on('propertyChanged', me.onPartnerChanged, me);
            partnerList.getFieldByName('gcPartnerForDealers_Field').on('propertyChanged', me.onPartnerChanged, me);
            if (me.PartnerSearchInterfaceEnabled()) {
                partnerList.getFieldByName('gcPartner_Field').Visible(false);
                partnerList.getFieldByName('gcPartnerForDealers_Field').Visible(false);
            }
            else {
                partnerList.getFieldByName('gcPartnerName_Field').Visible(false);
                if (me.IsDealerUser()) {
                    partnerList.getFieldByName('gcPartner_Field').Visible(false);
                }
                else {
                    partnerList.getFieldByName('gcPartnerForDealers_Field').Visible(false);
                }
            }
            partnerList.on('cellBeginEdit', me.onAssociatedPartnerGridBeginEdit);

            partnerList.getFieldByName('gcPartnerName_Field').renderer = "iconsRenderer";

            TS.UI.Renderers.grid.iconsRenderer = {

                getCellContent: function (field, dataItem) {
                    var displayText = '&nbsp';
                    if (dataItem.PartnerName !== null)
                        displayText = dataItem.PartnerName;
                    var content =
                        displayText
                        + '<div class="grid-cell icon-cell" style="float: right">'

                        + '<div class="grid-cell-icon">'
                        + '<a class="ts-grid-command" type="hyperlink" onclick="javascript: TS.UI.models.peek().onAssociatedPartnerSearch(' + dataItem.UID + ');">'
                        + '<i class="fa fa-search"></i></a></div>'

                        + '<div class="grid-cell-icon">'
                        + '<a class="ts-grid-command" type="hyperlink" onclick="javascript: TS.UI.models.peek().onAssociatedPartnerReset();">'
                        + '<i class="fa fa-remove"></i></a></div>'

                        + '</div>';

                    return content;
                }
            };
        }
        
        cat = me.CommandCategories.Navigation.Commands;

        if (cat != null)
            for (var i = 0; i < cat.length; i++) {
                if (cat[i].Code == "Reports") {
                    for (var j = 0; j < cat[i].commands.length; j++) {
                        cat[i].commands[j].handler = "_showReport";
                    }
                }
            }
    },

    onPartnerAdded: function (e) {
        var me = this,
            owner = me._getOwner(),
            rec = e.item;

        rec.PartnerTypeId = new ko.observable(null);
        rec.PartnerTypeName = new ko.observable(null);
        rec.DocumentPartnerId = new ko.observable(null);

        owner.performServerCommand('Dummy', true, null, null, false, true);
    },

    onAssociatedPartnerGridBeginEdit: function (e) {
        var me = this;

        if (e.record.DocumentPartnerId() != null)
            e.preventDefault();
    },


    onAssociatedPartnerSearch: function (e) {
        var me = this;

        me.performServerCommand({
            cmd: 'SearchLeasingPartner',
            submitModel: true,
            extraData: {
                UID: e
            },
            blockUI: true
        });
    },


    onAssociatedPartnerReset: function (e) {
        var me = this;

        var partnerList = me.getDomainProperty('dgLeasingPartnerCollection_Property');
        if (partnerList && partnerList.SelectedItem()) {
            partnerList.SelectedItem().PartnerId(null);
            partnerList.SelectedItem().PartnerName(null);
            partnerList.SelectedItem().ContactPersonId(null);
            partnerList.SelectedItem().ContactPersonName(null);
        }
    },


    onPartnerChanged: function (selectedRecord) {
        var me = this,
            partnerList = me.getDomainProperty('dgLeasingPartnerCollection_Property');

        if (selectedRecord.sender.SelectedItem()) {
            partnerList.SelectedItem().PartnerTypeId(selectedRecord.sender.SelectedItem().PartnerTypeId);
            partnerList.SelectedItem().PartnerTypeName(selectedRecord.sender.SelectedItem().PartnerTypeName);
        }
    },

    onSimulationBeginEdit: function (e) {
        var me = this,
            owner = me._Domain;

        if (e.fieldName == 'SimulationNumber') {
            e.preventDefault();
            owner.performServerCommand({ cmd: 'EditSimulation', submitModel: true, extraData: { SimulationId: e.record.DocumentId, SimulationSiteId: e.record.SiteId }, blockUI: true });
        }
        else if (owner.ReadOnly()) {
            e.preventDefault();
        }
    },

    _addSimulation: function () {
        var me = this;

        me.performServerCommand({ cmd: 'AddSimulation', submitModel: true, extraData: {}, blockUI: true });
    },

    initialize: function (config) {
        var me = this;

        me.parent(config);
       
        var simulationList = me.getDomainProperty('grdSimulations_Property');

        me.watchProperty(me.Document.ClientUniqueId, me.onUniqueIdChanged, me);
        me.watchProperty(me.Document.CityId, me.onCityIdChanged, me);
        me.watchProperty(me.Document.StreetId, me.onStreetIdChanged, me);

        if (simulationList != null) {
            simulationList.getFieldByName('gcSimulationNumber_Field').renderer = "hyperlinkGrid";

            TS.UI.Renderers.grid.hyperlinkGrid = {
                getCellClass: function (field, dataItem) {
                    return 'grid-hyperlink';
                }
            };
        }
        me.partnerTypeEditable = ko.computed(function () {
            if (me.EditPartnerEnabled() && me.HasNoSimulations())
                return true;
            return false;
        });
    },

    onUniqueIdChanged: function (newValue) {
        var me = this;

        me.performServerCommand({
            cmd: 'LoadPartner',
            submitModel: true,
            extraData: { UniqueID: newValue },
            blockUI: false
        });
    },

    onCityIdChanged: function (newValue) {
        var me = this;

        me.Document.StreetId(null);
        me.Document.StreetName(null);
    },

    onStreetIdChanged: function (newValue) {
        var me = this;

        me.performServerCommand({
            cmd: 'RefreshStreetData',
            submitModel: true,
            blockUI: true
        });
    },

    onResponsibleIdChanged: function (newValue) {
        var me = this;

        me.performServerCommand({
            cmd: 'UpdateResponsible',
            submitModel: true,
            blockUI: true
        });
    },

    onChecklistChanged: function (e) {
        var me = this,
            owner = me._getOwner(),
            val = e.newValue;

        if (e.oldValue == e.newValue)
            return;

        if (e.fieldName == 'Finalized') {
            val = e.newValue;
            if (val != null && val == true) {
                var now = new Date();
                now.setHours(0, 0, 0, 0);
                e.record.FinalizedDate(now);
                if (owner.CurrentUserId() != null) {
                    me.SelectedItem().UserId(owner.CurrentUserId());
                    me.SelectedItem().UserName(owner.CurrentUserName());
                }
            }
            else {
                e.record.FinalizedDate(null);
                e.record.UserId(null);
                e.record.UserName(null);
            }
        }
    },

    onChecklistAdded: function (e) {
        var me = this,
            owner = me._getOwner();

        e.item.Finalized(false);
    },
    
    _showReport: function (e) {
        var me = this;
        me.performServerCommand('Navigation.Reports.' + e.Code, true, null,
            function (r) {
                var me = this;

                if (r.modelData == undefined)
                    return;

                if (!r.modelData.ReportExportIsHtml)
                    return;

                var url = me.rootUrl + '/../Handlers/GetReport.ashx' + "?ReportId=" + r.modelData.ReportExportId + r.modelData.ReportExportParameters;
                window.open(url, '_blank');
            });
    }
});
